export enum FileCardOptionsTypeEnum {
  DUPLICATE = "duplicate",
  IS_EDIT = "isEdit",
  IS_REMOVE = "isRemove",
  COPY_URL = "copyUrl",
  DOWNLOAD = "download",
  CLOSE = "close",
}

export enum AssetCreateTypeEnum {
  IMAGE = "image",
  VIDEO = "video",
  PDF = "pdf",
  TEXT = "text",
  DOC = "doc",
  AUDIO = "audio",
}

export interface MediaUploadState {
  isLoading: boolean;
  url: string | null;
  progress: number;
}

export interface PreSignedUrlResponse {
  signedUrl: string;
  fileNameWithPrefix: string;
  contentType: string;
  url: string;
}
export interface ICreatePayload {
  file: File;
  type: string;
  mimeType: string;
  name: string;
}

export interface CreateAssetResponse {
  createdAt: string;
  updatedAt: string;
  type: AssetCreateTypeEnum;
  mimeType: string;
  fileName: string;
  filePath: string;
  fileSize: number;
  _id: string;
  url: string;
}

export type ContainerState = MediaUploadState;
